import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCourseApplicantDetail } from "../../../../services/apiCourseApplicant";
import Button from "../../../ui/Button";
import styles from "../../../layout/admin/Main.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import { AUTH_SHIBUYA, AUTH_UNIVERSITY } from "../../../../utils/config";
import { useAuth } from "../../../../contexts/AuthContext";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import DetailTable from "../../../ui/AdminDetailTable";
import { useNavigate } from "react-router-dom";

const CourseApplicantDetail = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座ID
  const { id } = useParams();
  // navigate
  const navigate = useNavigate();
  // ユーザーID
  const { userId } = useParams();
  // 申込者詳細データ
  const [courseDetail, setCourseDetail] = useState({});
  // ローディング表示
  const [loading, setLoading] = useState(false);

  const setAttendanceData = (data) => {
    const attendance = [];
    for (let i = 1; i <= 15; i++) {
      attendance.push({
        label: i + "回目(出席・欠席)",
        value: data["attendance" + i],
      });
    }
    return attendance;
  };

  const getTableElements = (data) => {
    return [
      { label: "講座ID", value: id },
      { label: "講座名", value: data.course_name },
      { label: "申込者ID", value: data.course_applicant_id },
      { label: "当選状況", value: data.lottery_status },
      { label: "学生番号(8桁)", value: data.login_id },
      {
        label: "氏名",
        value: data.is_wheelchair ? `【車いす】${data.name}` : data.name,
      },
      { label: "フリガナ", value: data.name_kana },
      { label: "郵便番号", value: data.postcode },
      { label: "住所", value: data.address },
      { label: "生年月日", value: data.birthday },
      { label: "年齢(年度末時点)", value: data.age },
      { label: "性別", value: data.gender },
      { label: "電話番号1", value: data.phone1 },
      { label: "メールアドレス1", value: data.mail1 },
      { label: "電話番号2", value: data.phone2 },
      { label: "メールアドレス2", value: data.mail2 },
      { label: "緊急連絡先(氏名)", value: data.e_name },
      { label: "緊急連絡先(続柄)", value: data.e_emereletion },
      { label: "緊急連絡先(電話番号)", value: data.e_phone },
      { label: "取得単位数", value: data.acquisition_unit },
      ...setAttendanceData(data),
      { label: "未受講・受講中・受講済み", value: data.attendance_status },
      { label: "申込方法", value: data.how_apply },
      { label: "キャンセル", value: data.is_cancel },
      { label: "備考", value: data.remarks },
      { label: "出欠情報更新日時", value: data.attendance_updated_date },
    ];
  };

  const getTableElementsUniv = (data) => {
    return [
      { label: "当選状況", value: data.lottery_status },
      { label: "学生番号(8桁)", value: data.login_id },
      {
        label: "氏名",
        value: data.is_wheelchair ? `【車いす】${data.name}` : data.name,
      },
      { label: "フリガナ", value: data.name_kana },
      { label: "郵便番号", value: data.postcode },
      { label: "住所", value: data.address },
      { label: "電話番号1", value: data.phone1 },
      { label: "メールアドレス1", value: data.mail1 },
      { label: "電話番号2", value: data.phone2 },
      { label: "メールアドレス2", value: data.mail2 },
      { label: "緊急連絡先(氏名)", value: data.e_name },
      { label: "緊急連絡先(電話番号)", value: data.e_phone },
      { label: "申込方法", value: data.how_apply },
    ];
  };

  useEffect(() => {
    (async function () {
      // ローディング表示開始
      setLoading(true);
      const data = await getCourseApplicantDetail(id, userId);
      if (data == undefined || !data) return;
      if (Object.keys(data).length === 0) {
        navigate("/admin/404");
      }
      // 権限確認
      if (user.authority == AUTH_UNIVERSITY) {
        if (!user.university_id == data.univ_id) {
          navigate("/admin/404");
        }
      }
      setCourseDetail(data);
      // ローディング表示終了
      setLoading(false);
    })();
  }, []);

  return (
    <div className={styles.main}>
      <ScreenTitle>講座管理</ScreenTitle>
      <SubScreenTitle>申込者詳細</SubScreenTitle>
      <div className={styles.displayflex}>
        {courseDetail.cannot_cancel ? (
          <Explanation
            children="※この講座はキャンセル不可です。"
            is_caution={true}
            sectionClass={styles.sectionPaddingRem}
          ></Explanation>
        ) : (
          <></>
        )}
        <div className={styles.buttonbox__left}>
          {user.authority == AUTH_SHIBUYA ? (
            <Link
              to={"/admin/course/detail/applicant/update/" + id + "/" + userId}
            >
              <Button type="button" styleType="new">
                申込情報変更
              </Button>
            </Link>
          ) : (
            <></>
          )}
          {user.authority == AUTH_SHIBUYA ? (
            <Link
              to={"/admin/course/detail/applicant/cancel/" + id + "/" + userId}
            >
              <Button type="button" styleType="new">
                申込キャンセル
              </Button>
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
      <DetailTable
        elements={
          user.authority == AUTH_SHIBUYA
            ? getTableElements(courseDetail)
            : getTableElementsUniv(courseDetail)
        }
      ></DetailTable>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to={"/admin/course/detail/" + id + "/2"}>
          講座詳細へ戻る
        </Link>
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};

export default CourseApplicantDetail;
